import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const formatLabel = (value) =>
  String(value || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "-" : date.toLocaleString();
};

const ACTION_COLORS = {
  create: "#2e7d32",
  update: "#ed6c02",
  delete: "#d32f2f",
};

export default function auditLogTableData({ logList = [] }) {
  return {
    columns: [
      { Header: "Date", accessor: "date", width: "18%", align: "left" },
      { Header: "Entity", accessor: "entity", align: "left" },
      { Header: "Action", accessor: "action", align: "center" },
      { Header: "Changed By", accessor: "changedBy", align: "left" },
      { Header: "Details", accessor: "details", width: "30%", align: "left" },
    ],

    rows: logList.map((log) => ({
      date: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {formatDate(log?.createdAt)}
        </MDTypography>
      ),
      entity: (
        <MDTypography variant="button" fontWeight="medium">
          {formatLabel(log?.entityType)} #{log?.entityId}
        </MDTypography>
      ),
      action: (
        <MDTypography
          variant="caption"
          fontWeight="bold"
          sx={{ color: ACTION_COLORS[log?.action] || "text.secondary", textTransform: "uppercase" }}
        >
          {log?.action}
        </MDTypography>
      ),
      changedBy: (
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {log?.admin?.fullName || log?.admin?.email || log?.changedBy || "-"}
        </MDTypography>
      ),
      details: (
        <MDBox
          component="pre"
          sx={{
            m: 0,
            fontSize: "0.7rem",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            maxHeight: 80,
            overflowY: "auto",
          }}
        >
          {JSON.stringify(log?.newValue ?? log?.previousValue ?? {}, null, 1)}
        </MDBox>
      ),
    })),
  };
}
